import React from 'react';
import Footer from './Footer';
import './App.css';

const HowItWorks = () => {
  return (
    <div className="home-container">
      {/* ── Hero ── */}
      <section className="hero-section how-hero">
        <div className="hero-left">
          <div className="hero-tag">The Process</div>
          <h1 className="hero-title">
            How <span>IndustriQuote</span> Works
          </h1>
          <p className="hero-subtitle" style={{ maxWidth: '650px' }}>
            IndustriQuote transforms complex product logic into structured, parametric systems that generate accurate configurations, pricing, and engineering outputs in real time.
          </p>
          <p className="hero-subtitle" style={{ maxWidth: '650px', marginTop: '-1rem', fontSize: '0.95rem', fontStyle: 'italic' }}>
            "If your product can be defined by rules, it can be configured instantly."
          </p>
        </div>
      </section>

      {/* ── Step-by-Step Process ── */}
      <section className="process-details-section">
        <div className="process-container">
          
          {/* Step 1 */}
          <div className="process-row">
            <div className="process-number">01</div>
            <div className="process-text">
              <h2>Model Your Product Logic</h2>
              <p>We start by translating your product line into a parametric system. This includes dimensional relationships, material dependencies, and valid configuration rules.</p>
              <div className="process-bullets">
                <div className="bullet-item"><span>•</span> Dimensional constraints</div>
                <div className="bullet-item"><span>•</span> Material dependencies</div>
                <div className="bullet-item"><span>•</span> SKU & model structures</div>
                <div className="bullet-item"><span>•</span> Pricing logic & costs</div>
              </div>
              <p className="process-subtext">The result is a digital representation that behaves exactly like your engineering team expects.</p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="process-row reverse">
            <div className="process-number">02</div>
            <div className="process-text">
              <h2>Build the Configuration Engine</h2>
              <p>We develop a custom configurator interface tailored to your workflow, ensuring users can only create valid configurations.</p>
              <div className="process-bullets">
                <div className="bullet-item"><span>•</span> Guided configuration flows</div>
                <div className="bullet-item"><span>•</span> Real-time validation</div>
                <div className="bullet-item"><span>•</span> Dynamic parameter updates</div>
                <div className="bullet-item"><span>•</span> Dependency enforcement</div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="process-row">
            <div className="process-number">03</div>
            <div className="process-text">
              <h2>Generate Outputs Instantly</h2>
              <p>As users configure, IndustriQuote produces mission-critical outputs in real time, ensuring consistency across sales and engineering.</p>
              <div className="process-outputs-grid">
                <div className="output-tag-item">Verified Model Numbers</div>
                <div className="output-tag-item">Accurate Pricing</div>
                <div className="output-tag-item">BOM Structures</div>
                <div className="output-tag-item">2D Engineering Drawings</div>
                <div className="output-tag-item">3D CAD Geometry</div>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="process-row reverse">
            <div className="process-number">04</div>
            <div className="process-text">
              <h2>Integrate With Your Systems</h2>
              <p>IndustriQuote fits into your existing infrastructure, eliminating manual data re-entry and reducing errors downstream.</p>
              <div className="integration-icons">
                <div className="int-box">ERP Systems</div>
                <div className="int-box">CRM Platforms</div>
                <div className="int-box">CAD & PLM</div>
              </div>
            </div>
          </div>

          {/* Step 5 */}
          <div className="process-row">
            <div className="process-number">05</div>
            <div className="process-text">
               <h2>Deploy and Scale</h2>
               <p>Deployed as a production-ready tool for internal teams, distributors, or customers. Extendable as your product line evolves.</p>
               <div className="use-cases-list">
                 <div className="use-case">Internal sales quoting</div>
                 <div className="use-case">Distributor self-service</div>
                 <div className="use-case">Customer-facing selection tools</div>
               </div>
            </div>
          </div>

        </div>
      </section>

      {/* ── Implementation & Outcome ── */}
      <section className="outcome-section">
        <div className="outcome-grid">
          <div className="outcome-card dark">
            <h3>Implementation Approach</h3>
            <ol className="styled-list">
              <li>Product and requirements analysis</li>
              <li>Rule and parameter modeling</li>
              <li>Configurator development</li>
              <li>Testing with real-world scenarios</li>
              <li>Deployment and integration</li>
              <li>Ongoing refinement</li>
            </ol>
          </div>
          <div className="outcome-card highlight">
            <h3>The Outcome</h3>
            <p>We replace manual quoting with a deterministic system that produces:</p>
            <ul className="outcome-bullets">
              <li><strong>Faster</strong> quote turnaround</li>
              <li><strong>Fewer</strong> configuration errors</li>
              <li><strong>Consistent</strong> technical outputs</li>
              <li><strong>Scalable</strong> sales operations</li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HowItWorks;
